import React from 'react';
import {segmentedControlStyles, selectStyles} from '../styles';

interface SegmentedControlOption {
  value: string;
  label: string;
}

interface SegmentedControlProps {
  label?: string;
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: any) => void;
  disabled?: boolean;
}

export const SegmentedControl = ({
  label,
  options,
  value,
  onChange,
  disabled = false,
}: SegmentedControlProps) => (
  <div style={segmentedControlStyles.container}>
    {label && <label style={selectStyles.label}>{label}</label>}
    <div style={segmentedControlStyles.track} role="tablist">
      {options.map(option => {
        const isSelected = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isSelected}
            disabled={disabled}
            onClick={() => onChange(option.value)}
            style={{
              ...segmentedControlStyles.segment,
              ...(isSelected ? segmentedControlStyles.segmentSelected : {}),
              ...(disabled ? segmentedControlStyles.segmentDisabled : {}),
            }}>
            {option.label}
          </button>
        );
      })}
    </div>
  </div>
);

export default SegmentedControl;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/components/SegmentedControl.tsx